import React, { useState, Fragment } from 'react'
import { Box } from '@mui/material';
import { msgDataSourceActions } from '_actions'
import BasicModal from "components/v3/common/BasicModal";
import basicModalStyles from "components/v2/views/Channels/ConnectChannels/Utilities/basicModalStyles";
import { useDispatch } from 'react-redux';
import BasicActionButton from "../../../../v3/common/BasicActionButton";

export const useRemoveAccountModal = () => {
	const [open, setOpen] = useState(false);
	const [removeMsgDataSourceId, setRemoveMsgDataSourceId] = useState(null);
	const [removeMsgDataSourceName, setRemoveMsgDataSourceName] = useState(null);

	const handleClickRemoveAccount = ({	msgDataSourceId, msgDataSourceName }) => {
		setRemoveMsgDataSourceId(msgDataSourceId);
		setRemoveMsgDataSourceName(msgDataSourceName);
		setOpen(true);
	}

	const handleCancel = () => {
		setRemoveMsgDataSourceId(null);
		setRemoveMsgDataSourceName(null);
		setOpen(false);
	}

	return {
		open, removeMsgDataSourceId, removeMsgDataSourceName,
		handleCancel, handleClickRemoveAccount
	}
}

/**
 * This modal is being used when the user wants to remove an account from a channel.
 * (e.g. Remove account @dogs123 and all it's handles (if it has some) from channel instagram)
 **/
export function RemoveAccountModal({open, removeMsgDataSourceId, removeMsgDataSourceName, handleCancel}) {
	const [isLoading, setIsLoading] = useState(false);
	const dispatch = useDispatch()

	const handleClickRemove = (e) => {
		e.preventDefault()
		setIsLoading(true)
		dispatch(msgDataSourceActions.deleteMsgDataSource(removeMsgDataSourceId))
	}

	return (
		<Fragment>
			<BasicModal
				open={open}
				handleClose={handleCancel}
				title={'Remove this Account?'}
				style={{borderRadius: '20px'}}
			>

				<Box sx={basicModalStyles.description}>
					Do you want to remove <strong>{removeMsgDataSourceName}</strong>?
				</Box>

				<Box sx={basicModalStyles.buttonContainer} pt={2}>
					<Box />
					<Box sx={basicModalStyles.buttonRight}>
						<BasicActionButton action={handleClickRemove} label={'Remove'} disabled={isLoading}/>
					</Box>
				</Box>
			</BasicModal>
		</Fragment>
	)
}